// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"e700022e","91":"8b66ec70","634":"9b0bfc30","710":"75b92d32","907":"ad262340"}[chunkId] + ".chunk.js";
};